function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.329 4.33a4.33 4.33 0 11-8.659 0 4.33 4.33 0 018.659 0zm-1.998 0a2.331 2.331 0 10-4.663 0 2.331 2.331 0 004.663 0z",
  fill: "url(#ok_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.995 9.311c-.001.564-.284 1.09-.755 1.399a7.663 7.663 0 01-2.314 1.032l2.01 1.966.032.033a1.332 1.332 0 11-1.913 1.854l-2.056-2.128-2.051 2.124-.032.032a1.332 1.332 0 01-1.856-1.912l2.013-1.968a6.634 6.634 0 01-.363-.101 7.688 7.688 0 01-1.951-.933 1.68 1.68 0 01-.755-1.398 1.21 1.21 0 01.678-1.102 1.272 1.272 0 011.332.125 5.068 5.068 0 005.971 0c.384-.292.9-.34 1.332-.125.42.205.684.635.678 1.102z",
  fill: "url(#ok_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ok_svg__paint0_linear",
  x1: 4.877,
  y1: 0,
  x2: 12.916,
  y2: 1.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ok_svg__paint1_linear",
  x1: 4.877,
  y1: 0,
  x2: 12.916,
  y2: 1.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgOk;